module.exports = __webpack_public_path__ + "static/Laptop2_mobile-5a56cc3695cd43ef408ae9937471daff.mp4";